import { render, staticRenderFns } from "./vue-pagination.vue?vue&type=template&id=5df0003a&scoped=true"
import script from "./vue-pagination.vue?vue&type=script&lang=js"
export * from "./vue-pagination.vue?vue&type=script&lang=js"
import style0 from "./vue-pagination.vue?vue&type=style&index=0&id=5df0003a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0003a",
  null
  
)

export default component.exports